import Home from './Home';
import { useEffect, useState } from 'react';
import { React } from "react";
import { Routes, Route } from "react-router-dom";
import ProductListing from './ProductListing';
import ProductDetails from './ProductDetails';
import AddCart from './AddCart';
import Checkout from './Checkout';
import UserLogin from './UserLogin';
import Register from './Register';
import OrderList from './component/OrderList';
import Contact from './pages/Contact';
import About from './pages/About';
import Faqs from './pages/Faqs';
import WishLisht from './WishLisht';
import MyOrders from './MyOrders';
import MyAddress from './MyAddress';
import MyWallet from './MyWallet';
import MyContact from './MyContact'
import MyProfile from './MyProfile';
import MyWishlist from './MyWishlist';
import MyCoupons from './MyCoupan';
import GetOffers from './pages/GetOffers';
import Header from './component/Header';
import ProductCategoryList from './ProductCategoryList';
import CategoriesPage from './CategoriesPage';
import CategoryDropdown from './CategoryDropdown';
import CategoryCart from './component/CategoryCart';
import ArrivalCart from './component/ArrivalCart';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TremsCondition from './pages/TremsCondition';
import { CartProvider } from './context/CartContext';
import { SearchProvider } from './context/SearchContext';
import { AuthProvider } from './utils/AuthContext';
import { WishlistProvider } from "./context/WishlistContext";
import api from './api';
import { ToastContainer } from 'react-toastify';
import NewArrival from './component/NewArrival';
import ShipingDelivery from './component/ShipingDelivery';
import CancellationRefund from './component/CancellationRefund';
import ComboPack from './component/ComboPack';
import Tranding from './component/Tranding';
import NewCollection from './component/NewCollection';

function App() {
  const [sections, setSections] = useState([]);
  useEffect(() => {
    console.log("dkjhfiwhyfi1")
    const fetchSections = async () => {
      console.log("dkjhfiwhyfi2")
      try {
        const res = await api.get("/user/getSections");
        console.log("dkjhfiwhyfi3", res)
        setSections(res.data.data);
      } catch (error) {
        console.error("Failed to fetch sections:", error);
      }
    };

    fetchSections();
  }, []);
  return (
    <div className="App">
      <WishlistProvider>
        <CartProvider>
          <SearchProvider>
            <AuthProvider>
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="white" // or "light" / "colored"
              />
              {/* Pass sections to Header */}
              <Header sections={sections} />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product-listing/:categoryId" element={<ProductListing />} />
                <Route path="/product-details/:_id" element={<ProductDetails />} />
                <Route path='/shop-by-category' element={<CategoryCart />} />
                <Route path='/new-arrivals' element={<ArrivalCart />} />
                <Route path="/add-to-cart" element={<AddCart />} />
                <Route path="/check-out" element={<Checkout />} />
                <Route path="/order-placed/:id" element={<OrderList />} />
                <Route path="/register" element={<Register />} />
                <Route path="/user-login" element={<UserLogin />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/about-us" element={<About />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/wish-list" element={<WishLisht />} />
                <Route path="/offers-listing/:_id" element={<GetOffers />} />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route path="/my-address" element={<MyAddress />} />
                <Route path="/my-wallet" element={<MyWallet />} />
                <Route path="/my-Profile" element={<MyProfile />} />
                <Route path="/my-coupan" element={<MyCoupons/>}/>
                <Route path="/my-wishlist" element={<MyWishlist />} />
                <Route path="/user-contact" element={<MyContact />} />
                <Route path="/privacy-Policy" element={<PrivacyPolicy />} />
                <Route path="/terms-condition" element={<TremsCondition />} />
                <Route path="/new-rivals" element={<NewArrival />} />
                <Route path="/shiping-delivery" element={<ShipingDelivery />} />
                <Route path="/cancellation-refund" element={<CancellationRefund />} />
                <Route path="/combo-pack" element={<ComboPack />} />
                <Route path="/trending" element={<Tranding />} />
                <Route path="/new-collection" element={<NewCollection />} />
                <Route path="/product-category-list/:categoryId" element={<ProductCategoryList />} />
                <Route path="/product-category" element={<CategoriesPage />} />
                <Route path="/product-category-drop-down" element={<CategoryDropdown />} />
              </Routes>
            </AuthProvider>
          </SearchProvider>
        </CartProvider>
      </WishlistProvider>
    </div>
  )
}


export default App;
